const initialState = {
  isMobile: undefined,
  isLoad: false,
};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_isMobile":
      return { ...state, isMobile: payload };
    case "SAVE_isLoad":
      return { ...state, isLoad: payload };
    case "SAVE_isReady":
      return { ...state, isReady: payload };
    case "SAVE_Message":
      return { ...state, message: payload };
    case "SAVE_UserInfo":
      return { ...state, userInfo: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
